import ACTIVE_IMG_BORDER_US_DOLLAR from 'assets/images/dollar-active.svg';
import ACTIVE_IMG_US_DOLLAR from 'assets/images/dollar-no-border-active.svg';
import GLOSSARY_IMG_GB_POUND from 'assets/images/glossary/GlossaryDeposited.svg';
import GLOSSARY_IMG_US_DOLLAR from 'assets/images/glossary/glossaryDepositedDollar.svg';
import ACTIVE_IMG_BORDER_GB_POUND from 'assets/images/icons/currency-pound-purple.svg';
import IMG_BORDER_GB_POUND from 'assets/images/menu/cashup-black.svg';
import IMG_BORDER_US_DOLLAR from 'assets/images/menu/cashup-dollar-black.svg';
import ACTIVE_IMG_GB_POUND from 'assets/images/xTakedepositicon.svg';

// SEE: https://en.wikipedia.org/wiki/List_of_ISO_3166_country_codes
export const LOCALE = {
  uae: 'ar-AE',
  deu: 'de-DE',
  gbr: 'en-GB',
  usa: 'en-US',
};

// SEE: https://en.wikipedia.org/wiki/List_of_circulating_currencies
export const ABBREVIATION = {
  aed: 'AED',
  eur: 'EUR',
  gbp: 'GBP',
  usd: 'USD',
};

export const COUNTRY_CURRENCY = {
  GB: 'pound',
  US: 'dollar',
  AE: 'dirham',
};

export const CURRENCY_BORDER_ICONS = {
  GB: IMG_BORDER_GB_POUND,
  US: IMG_BORDER_US_DOLLAR,
};

export const CURRENCY_ACTIVE_BORDER_ICONS = {
  GB: ACTIVE_IMG_BORDER_GB_POUND,
  US: ACTIVE_IMG_BORDER_US_DOLLAR,
};

export const CURRENCY_ACTIVE_ICONS = {
  GB: ACTIVE_IMG_GB_POUND,
  US: ACTIVE_IMG_US_DOLLAR,
};

export const GLOSSARY_CURRENCY_ICONS = {
  GB: GLOSSARY_IMG_GB_POUND,
  US: GLOSSARY_IMG_US_DOLLAR,
};
